import { render, staticRenderFns } from "./SlglrsStaticPage.vue?vue&type=template&id=f1e508ee&scoped=true&"
import script from "./SlglrsStaticPage.vue?vue&type=script&lang=js&"
export * from "./SlglrsStaticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e508ee",
  null
  
)

export default component.exports